/* eslint-disable @typescript-eslint/no-var-requires */

export const IllusDietaryRestrictions = require('./Illus-DietaryRestrictions.png');
